export default __webpack_public_path__ + "static/media/297.f5ea6763.png";